import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="p-12 text-center text-muted-foreground uppercase tracking-[0.3em] text-xs">
        Checking session...
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  // Force password change before anything else
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="max-w-xl mx-auto px-4 py-12 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-destructive font-bold mb-3">Access Denied</p>
        <h1 className="font-display font-black uppercase text-3xl tracking-tight">
          You don't have permission for this page
        </h1>
      </div>
    );
  }
  return children;
}
